import "../css/Home.css";

const Home = () => {
  return (
    <main className="home">

      {/* HERO */}
      <section className="home-hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>
            Coffee.<br />
            Calm.<br />
            Comfort.
          </h1>
          <p>
            A modern café experience inspired by warmth,
            simplicity, and time well spent.
          </p>
        </div>
      </section>

      {/* BIG STATEMENT */}
      <section className="home-statement">
        <h2>
          This is not a place to rush.<br />
          This is a place to stay.
        </h2>
      </section>

      {/* MOOD STRIP */}
      <section className="home-mood">
        <img src="https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg" alt="" />
        <img src="https://images.pexels.com/photos/374885/pexels-photo-374885.jpeg" alt="" />
        <img src="https://images.pexels.com/photos/1833306/pexels-photo-1833306.jpeg" alt="" />
      </section>

      {/* ATMOSPHERE */}
      <section className="home-atmosphere">
        <div className="atmo-text">
          <h2>The Atmosphere</h2>
          <p>
            Wooden tables. Warm lights.  
            Coffee brewing slowly in the background.
          </p>
        </div>
        <div
          className="atmo-image"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/2074130/pexels-photo-2074130.jpeg)",
          }}
        />
      </section>

      {/* TEXT BREAK */}
      <section className="home-text-break">
        <p>
          Some people come here to work.<br />
          Some come to think.<br />
          Some just come to breathe.
        </p>
      </section>

      {/* PHILOSOPHY */}
      <section className="home-philosophy">
        <h2>Our Philosophy</h2>
        <p>
          Coffee is not rushed here.  
          It’s brewed with patience and served with intention.
        </p>
      </section>

      {/* EXPERIENCE */}
      <section className="home-experience">
        <div className="exp-card">
          <img src="https://images.pexels.com/photos/302894/pexels-photo-302894.jpeg" alt="" />
          <h3>Mornings</h3>
          <p>Soft light & first brews.</p>
        </div>

        <div className="exp-card">
          <img src="https://images.pexels.com/photos/374888/pexels-photo-374888.jpeg" alt="" />
          <h3>Afternoons</h3>
          <p>Books, work & quiet cups.</p>
        </div>

        <div className="exp-card">
          <img src="https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg" alt="" />
          <h3>Evenings</h3>
          <p>Warm lamps & conversations.</p>
        </div>
      </section>

      {/* FULL IMAGE */}
      <section
        className="home-full"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/373639/pexels-photo-373639.jpeg)",
        }}
      >
        <p>
          A place where time slows<br />
          and coffee stays warm.
        </p>
      </section>

      {/* FINAL TEXT */}
      <section className="home-final-text">
        <h2>
          Coffee tastes better<br />
          when you’re not in a hurry.
        </h2>
      </section>

      {/* INVITE */}
      <section className="home-invite">
        <h2>Come In. Sit Down.</h2>
        <p>No rush. Just coffee.</p>
      </section>

    </main>
  );
};

export default Home;
